import React from "react";
import { Modal } from "react-bootstrap";

import IconHeader from "components/IconHeader";
import IconSubheader from "components/IconSubheader";
import Button from "components/Button";
import Alert from "components/Alert";

import "./SimpleModal.scss";

interface SimpleModalProps {
  onClose: (clickingOutsideModal?: boolean) => void;
  onSubmit?: (...args: unknown[]) => void;
  show: boolean;
  title: string;
  buttonText: string;
  children: React.ReactNode;
  btnDisabled?: boolean;
  isFetching?: boolean;
  isXhrRequest?: boolean;
  showCloseButton?: boolean;
  hideActions?: boolean;
  hideHeader?: boolean;
  closeButtonText?: string;
  size?: "sm" | "lg" | "xl";
  error?: string;
  subtext?: string;
}

const SimpleModal = ({
  onClose,
  show,
  title,
  children,
  buttonText,
  onSubmit,
  btnDisabled,
  isXhrRequest,
  isFetching,
  closeButtonText = "Cancel",
  error,
  showCloseButton,
  hideActions,
  size,
  subtext,
  hideHeader,
}: SimpleModalProps) => {
  return (
    <Modal
      centered
      scrollable
      size={size}
      show={show}
      onHide={() => {
        const clickingOutsideModal = true;
        onClose(clickingOutsideModal);
      }}
      className="icon-modal icon-modal"
    >
      {!hideHeader && (
        <Modal.Header className="modal-header" closeButton={showCloseButton}>
          <IconHeader
            id="contained-modal-title-vcenter"
            variant="cardHeader"
            headerText={title}
          />
          <IconSubheader subheader={subtext} />
        </Modal.Header>
      )}
      <Modal.Body className="modal-body">
        {children}
        {error && <Alert type="error" msg={error} />}
      </Modal.Body>
      {!hideActions && (
        <Modal.Footer>
          {showCloseButton && (
            <Button
              name="cancel"
              btnLabel={closeButtonText}
              onClick={() => onClose()}
              color="cancel"
            />
          )}
          <Button
            name="submit"
            btnLabel={buttonText}
            disabled={btnDisabled}
            withArrow={isXhrRequest}
            loading={isFetching}
            onClick={() => (onSubmit ? onSubmit() : onClose())}
          />
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default SimpleModal;
